export enum ContentKind {
  News = 'news',
  Birthdays = 'birthdays',
  PriorityNews = 'priority-news',
  Activities = 'activities',
  Dining = 'dining',
  Weather = 'weather',
  Mail = 'mail',
  ScheduledVideo = 'scheduled-video',
  YoutubeLive = 'youtube-live',
  Status = 'status'
}

// Status is synthetic and has no provider, so feed-keyed records must exclude it. Derived rather
// than declared separately, because two hand-maintained lists of the same nine kinds would drift.
export type FeedKind = Exclude<ContentKind, ContentKind.Status>;
